/* tslint:disable */

declare var Object: any;
export interface ERPpurchaseReturnInterface {
  "id"?: number;
}

export class ERPpurchaseReturn implements ERPpurchaseReturnInterface {
  "id": number;
  constructor(data?: ERPpurchaseReturnInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchaseReturn`.
   */
  public static getModelName() {
    return "ERPpurchaseReturn";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchaseReturn for dynamic purposes.
  **/
  public static factory(data: ERPpurchaseReturnInterface): ERPpurchaseReturn{
    return new ERPpurchaseReturn(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchaseReturn',
      plural: 'ERPpurchaseReturns',
      path: 'ERPpurchaseReturns',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchaseReturn.ts